// Secondary closed-loop outputs for ACTIVE buildings only.
// These are non-blocking background recovery streams; primary production
// chains remain authoritative for required material/gas handling.

import { EM2C_BUILDINGS } from "./em2c-buildings";

export const LOGICAL_BYPRODUCT_OUTPUTS = {
  greenhouse: { oxygen: 0.8, organic_waste: 0.08 },
  hydroponics: { oxygen: 1.2, organic_waste: 0.06 },
  agri_complex: { oxygen: 2.5, organic_waste: 0.20 },
  food_processing: { organic_waste: 0.12, waste: 0.04 },
  community_center: { wastewater: 0.05, organic_waste: 0.02, waste: 0.03 },
  medical_center: { wastewater: 0.03, waste: 0.05 },
  medical_complex: { wastewater: 0.08, waste: 0.12 },
};

export function applyBuildingByproductRules() {
  for (const [buildingId, outputs] of Object.entries(LOGICAL_BYPRODUCT_OUTPUTS)) {
    const def = EM2C_BUILDINGS[buildingId];
    if (def) def.nonBlockingOutputs = { ...outputs };
  }
  return true;
}

applyBuildingByproductRules();
